import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import { rightPaneStore } from "csi/state/rootStore";
import { C8Node } from "csi/typings";
import { ConfirmDialog, DataGridCardProps, IconButton, Text } from "designSystem/index";
import { black, white } from "designSystem/styles/color";
import React, { FunctionComponent, MouseEvent, useState } from "react";
import "src/css/variables.css";
import { ComplianceAnalysisPaneComponent } from "./ComplianceAnalysisPaneComponent";
import { clickableStyle } from "designSystem/styles/style-functions";
import { designType } from "designSystem/components/dataGrid/DataGrid";
import { hasComplianceAnalysisAdminRole } from "./complianceAnalysisRightPaneService";


const PREFIX = "ComplianceAnalysisCard";

export const classes = {
	bold: `${PREFIX}textBold`,
	clickable: `${PREFIX}clickable`,
	iconDelete: `${PREFIX}iconDelete`,
	iconDiv: `${PREFIX}iconDiv`,
	infoPane: `${PREFIX}infoPane`,
	itemList: `${PREFIX}itemList`,
	nodeName: `${PREFIX}nodeName`,
	panelCard: `${PREFIX}panelCard`,
	text: `${PREFIX}text`,
};

export const StyledRoot = styled("div")((
	{
		theme,
	},
) => ({
	padding: 12,
	borderBottom: "1px solid rgba(0, 0, 0, .05)",
	boxSizing: "border-box",
	display: "flex",
	background: white[50],
	[`& .${classes.bold}`]: {
		fontWeight: "bold",
	},
	[`&.${classes.itemList}`]: {
		backgroundColor: "inherit",
		borderBottom: "none",
	},
	[`&.${classes.clickable}`]: clickableStyle(theme),
	[`& .${classes.iconDelete}`]: {
		color: "#E75E4F",
		marginleft: "70px",
	},
	[`& .${classes.iconDiv}`]: {
		alignItems: "center",
		display: "flex",
		height: "auto",
		justifyContent: "right",
	},
	[`& .${classes.infoPane}`]: {
		backgroundColor: "inherit",
		borderBottom: "none",
		display: "flex",
		flexDirection: "row",
		maxWidth: "auto",
		minWidth: 0,
		"& span": {
			height: 18,
		},
		width: "100%",
	},
	[`& .${classes.nodeName}`]: {
		color: black[100],
		fontSize: 12,
		fontWeight: "bold",
		lineHeight: "14px",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		width: "100%",
	},
	[`& .${classes.panelCard}`]: {
		width: "100%",
	},
	[`& .${classes.text}`]: {
		color: black[100],
		fontSize: 12,
		lineHeight: "14px",
		overflow: "hidden",
		paddingTop: "5px",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		width: "100%",
	},
}));

export interface ComplianceAnalysisCardProps extends DataGridCardProps<C8Node>
{
	cardDesignType: designType;
	PanelContent: FunctionComponent;
}

export const ComplianceAnalysisCard: FunctionComponent<ComplianceAnalysisCardProps> = (props) => {
	const [isConfirmDialogOpen, setisConfirmDialogOpen] = useState<boolean>(false);
	const { cardDesignType, item, onDelete, PanelContent } = props;

	function deleteProductComplianceAnalysisItem(event: MouseEvent<HTMLButtonElement>) {
		if (rightPaneStore.selected instanceof ComplianceAnalysisPaneComponent) {
			const component: ComplianceAnalysisPaneComponent = rightPaneStore.selected as ComplianceAnalysisPaneComponent;

			component.deleteProductComplianceAnalysis(item);
			onDelete();
		}
		setisConfirmDialogOpen(false);
	}

	const itemNumber = item["_indexForList"] + ".";

	return (
		<StyledRoot className={cardDesignType as string == "list" ? classes.itemList : classes.clickable}>
			<div className={classes.infoPane}>
				<Text
					color="textPrimary"
					style={{ marginRight: "5px" }}
					text={itemNumber}
				/>
				<PanelContent />
			</div>
			{( hasComplianceAnalysisAdminRole() && (
				<div className={classes.iconDiv}>
					<IconButton
						onClick={() => setisConfirmDialogOpen(!isConfirmDialogOpen)}
						size="small"
					>
						<CloseIcon className={classes.iconDelete} />
					</IconButton>
				</div>
			)
			)}
			<ConfirmDialog
				category="error"
				confirmRes="BUTTON_CONFIRM"
				messageRes="ComplianceAnalysisDeleteAnalysisItem"
				onClick={(e) => e.stopPropagation()}
				onClose={() => {setisConfirmDialogOpen(false);}}
				onConfirm={deleteProductComplianceAnalysisItem}
				open={isConfirmDialogOpen}
				secondaryButtonRes="BUTTON_CLOSE"
				titleRes="ComplianceAnalysisDeleteAnalysisItemTitle"
			/>
		</StyledRoot>
	);
};
